import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { DEMO_LOGINS, ELoginAs } from '@webtrader/core/constants/account';

export function useLoginInputLabel(isShowSubTab: boolean | undefined, selectedTab: ELoginAs) {
  const { t } = useTranslation();

  return useMemo(() => {
    if (isShowSubTab) {
      return t('Email');
    }

    if (selectedTab === ELoginAs.LIVE) {
      return `${t('Email')} / ${t('Username')}`;
    }

    if (DEMO_LOGINS.includes(selectedTab)) {
      return t('Account ID', { context: 'demo' });
    }

    return t('Account ID', { context: 'live' });
  }, [isShowSubTab, selectedTab, t]);
}
